export function removerAcentos(s) {
    return s ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
}
